// extracted by mini-css-extract-plugin
module.exports = {"link":"UserSettingsLayout_link__fj9O4","active":"UserSettingsLayout_active__XpL3n"};